import classNames from 'classnames';
import React from 'react';
import * as styles from './ColumnResizeHandler.module.scss';
import addTestId from '../../../utils/addTestId';

interface ColumnResizeHandlerProps {
  firstRow: boolean;
  resizing: boolean;
  onResizeStart: (initial: { width: number; offset: number }) => void;
}

const ColumnResizeHandler = ({
  firstRow,
  resizing,
  onResizeStart,
}: ColumnResizeHandlerProps) => (
  <button
    type="button"
    className={classNames(styles.container, { [styles.firstRow]: firstRow })}
    onMouseDown={(e) => {
      const td = e.currentTarget.closest('td');
      if (td) {
        onResizeStart({
          width: td.getBoundingClientRect().width,
          offset: e.pageX,
        });
      }
    }}
    {...addTestId('tableColumnResizeHandler')}
  >
    <span
      className={classNames(styles.line, { [styles.dragging]: resizing })}
    />
  </button>
);

export default ColumnResizeHandler;
